var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZitaraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 244,
    viewBox: "0 0 563 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.29 147.09V162.58H151.13V145.48H106.45L142.63 105.16H119.2L81.29 147.09Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.08 81.29H182.4V162.58H162.08V81.29ZM172.24 43.87C164.98 43.87 159.66 49.35 159.66 56.29C159.66 63.39 164.98 68.87 172.24 68.87C179.66 68.87 185.14 63.39 185.14 56.29C185.15 49.35 179.66 43.87 172.24 43.87Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M299.98 80C282.72 80 268.37 90.32 265.79 106.45L283.85 109.67C284.82 100.96 291.11 95.48 299.98 95.48C309.82 95.48 316.11 101.12 316.11 110.32V111.13L300.95 112.58C276.76 115.16 264.66 123.71 264.66 139.67C264.66 153.54 275.79 163.87 291.76 163.87C301.76 163.87 311.6 158.71 316.12 150.81V162.58H335.8V113.06C335.78 91.45 321.27 80 299.98 80ZM316.11 127.42C316.11 139.35 308.85 148.87 296.27 148.87C288.85 148.87 284.33 144.68 284.33 139.03C284.33 133.22 289.81 128.71 300.62 127.42L316.1 125.65V127.42H316.11Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M372.45 96.13V81.29H352.13V162.58H372.45V132.74C372.45 108.55 382.77 99.03 394.22 99.03C397.77 99.03 401.64 99.68 404.54 100.97L405.83 81.29C403.41 80.48 399.86 80 396.96 80C387.13 80 376.48 86.93 372.45 96.13Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M445.48 80C428.22 80 413.87 90.32 411.29 106.45L429.35 109.67C430.32 100.96 436.61 95.48 445.48 95.48C455.32 95.48 461.61 101.12 461.61 110.32V111.13L446.45 112.58C422.26 115.16 410.16 123.71 410.16 139.67C410.16 153.54 421.29 163.87 437.26 163.87C447.26 163.87 457.1 158.71 461.62 150.81V162.58H481.3V113.06C481.29 91.45 466.77 80 445.48 80ZM461.61 127.42C461.61 139.35 454.35 148.87 441.77 148.87C434.35 148.87 429.83 144.68 429.83 139.03C429.83 133.22 435.31 128.71 446.12 127.42L461.6 125.65V127.42H461.61Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.35 129.67V135.96C218.35 154.99 230.13 163.86 245.95 163.86C250.45 163.86 254.48 163.21 258.51 161.76L257.12 144.72C254.22 146.17 250.15 146.66 246.84 146.66C240.04 146.66 235.45 141.76 235.45 134.02V129.66H218.35V129.67Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.16 81.29H84.03V98.39H150.16V81.29Z",
    fill: "#F8B918"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M259.96 81.29H235.44V56.77H218.35V81.29H193.83V98.38H218.35V122.9H235.44V98.38H259.96V81.29Z",
    fill: "#F8B918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZitaraLogo);
export default __webpack_public_path__ + "static/media/zitara-logo.b1cc02a21f6af5b1a6449cdda25353d6.svg";
export { ForwardRef as ReactComponent };